/** @format */

import React, { useEffect, useReducer, useState } from "react";
import Select from "react-select";
import BackgroundImg from "../../layout/BackgroundImg";
import Logo from "../../layout/Logo";
// import imgLogo from './assets/images/logo-light.png';
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { signUp } from "../../features/auth/authSlice";
import {
  fetchUserList,
  fetchUserTable,
  userRoleList,
} from "../../features/commonSlice/commonSlice";
import { addUser } from "../../features/userSlice/userSlice";
import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import { Button, Pagination, OverlayTrigger, Tooltip } from "react-bootstrap";

const ClientSignUp = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    mobile_no: "",
    role: null,
    manager: null,
    credit_in: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const decodeToken = useDecodedToken();

  const {
    usersData,
    usersTableData,
    roleDataList,
    status: commonStatus,
  } = useSelector((state) => state.influencer);

  const [langList, setLangList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [usersTableList, setUsersTableList] = useState([]);
  const [usersList, setUsersList] = useState({ data: [] });
  const [errors, setErrors] = useState({});

  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [showToaster, setShowToaster] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [roleList, setRoleList] = useState([])

  useEffect(() => {
    dispatch(fetchUserList());
    dispatch(fetchUserTable());
    dispatch(userRoleList())
  }, []);

  useEffect(() => {
    if (commonStatus === "succeeded") {
      setUsersList(usersData);
    }
  }, [commonStatus, usersData]);

  useEffect(() => {
    if (commonStatus === "succeeded") {
      setUsersTableList(usersTableData || []);
    }
  }, [commonStatus, usersTableData]);


  useEffect(() => {
    setRoleList(roleDataList?.data)

  }, [roleDataList])

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error when the user starts typing or interacting
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear any existing error for this field
    }));

    // Handle phoneNo input to allow only numbers
    if (name === "mobile_no" || name === "credit_in") {
      if (value === "" || /^[0-9]{0,10}$/.test(value)) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }

    // Check if passwords match for both password and confirmPassword
    if (name === "password" || name === "confirmPassword") {
      if (formData.password !== value && name === "confirmPassword") {
        setPasswordError("Passwords do not match");
      } else if (formData.password === value || name === "password") {
        setPasswordError("");
      }
    }
  };

  const handleSelectChange = (name, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear the error for the specific select field
    }));
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    try {
      const clientData = {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        mobile_no: formData.mobile_no,
        role: formData.role?.value || "",
        manager: formData.manager?.value || "",
        credit_in: Number(formData.credit_in) || "",
      };

      dispatch(addUser(clientData))
        .unwrap()
        .then((result) => {
          if (result.status) {
            toast.success(result.message);
            setShowToaster(true);

            // Clear the form
            setFormData({
              name: "",
              email: "",
              password: "",
              mobile_no: "",
              role: null,
              manager: null,
              credit_in: "",
            });

            // Create new user entry for table
            const newUser = {
              id: result?.data?.id || Math.random(),
              name: clientData.name || " ",
              email: clientData.email || " ",
              mobile_no: clientData.mobile_no || " ",
              role_name: formData.role?.label || "-",
              credit_in: formData.credit_in || " ",
              MgrName:
                usersList?.data?.find(
                  (user) => user.value === formData.manager?.value,
                )?.label || "-",
            };

            // Append to the bottom of the table
            setUsersTableList((prevList) => [...prevList, newUser]);
          } else {
            setLoginError(result.message);
            setErrorData(result.form_err);
          }
        })
        .catch((err) => {
          setLoginError(err.message);
          setErrorData(err.form_err || []);
          toast.error(err.message);
        });
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const mapErrors = (errorData) => {
    const errorMap = {};
    errorData.forEach((error) => {
      if (!errorMap[error.param]) {
        errorMap[error.param] = error.msg;
      }
    });
    return errorMap;
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  const handleToggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  useEffect(() => {
    const errorsValue = mapErrors(errorData);
    setErrors(errorsValue);
  }, [errorData]);

  // const roleList = [
  //   { value: "2", label: "Sales Team Lead" },
  //   { value: "3", label: "Digital Marketing Team Lead" },
  //   { value: "4", label: "Sales" },
  //   { value: "5", label: "Digital Marketing" },
  //   { value: "6", label: "Client" },
  //   { value: "8", label: "Finance" },
  //   { value: "10", label: "Admin" },
  //   { value: "11", label: "Onboarding" },
  // ];

  const totalRecords = usersTableList?.length || 0;

  const totalPages =
    recordsPerPage === 2000 ? 1 : Math.ceil(totalRecords / recordsPerPage);

  const indexOfLast =
    recordsPerPage === 2000 ? totalRecords : currentPage * recordsPerPage;

  const indexOfFirst =
    recordsPerPage === 2000 ? 0 : indexOfLast - recordsPerPage;

  const currentData =
    recordsPerPage === 2000
      ? usersTableList
      : usersTableList.slice(indexOfFirst, indexOfLast);
  const getPaginationItems = (current, total) => {
    const pages = [];

    pages.push(1);

    if (current > 3) pages.push("...");

    for (
      let i = Math.max(2, current - 1);
      i <= Math.min(total - 1, current + 1);
      i++
    ) {
      pages.push(i);
    }

    if (current < total - 2) pages.push("...");

    if (total > 1) pages.push(total);

    return pages;
  };

  const handleEdit = (rowData) => {
    navigate(`/update-user-details/${rowData?.id}`, { state: rowData });
  };

  useEffect(() => {
    console.log("role data list ==>", roleList);

  }, [roleList])

  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="name"
              placeholder="Enter Name"
              value={formData.name}
              onChange={handleChange}
            />
            <div className="text-danger">
              {errors.name && <>{errors.name}</>}
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="Enter Email"
              value={formData.email}
              onChange={handleChange}
            />
            <div className="text-danger">
              {errors.email && <>{errors.email}</>}
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="mb-3 position-relative">
            <label htmlFor="password" className="form-label">
              Password <span className="text-danger">*</span>
            </label>
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              name="password"
              placeholder="Enter Password"
              value={formData.password}
              onChange={handleChange}
            />
            <button
              className="btn btn-link position-absolute end-0 text-decoration-none text-muted password-addon"
              type="button"
              style={{ top: "28.05px" }}
              onClick={handleTogglePassword}
            >
              <i
                className={`ri-${showPassword ? "eye-fill" : "eye-off-fill"} align-middle`}
              ></i>
            </button>
            <div className="text-danger">
              {errors.password && <>{errors.password}</>}
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="mb-3">
            <label htmlFor="mobile_no" className="form-label">
              Mobile No <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="mobile_no"
              placeholder="Enter Mobile No"
              maxLength={10}
              value={formData.mobile_no}
              onChange={handleChange}
            />
            <div className="text-danger">
              {errors.mobile_no && <>{errors.mobile_no}</>}
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="mb-3">
            <label htmlFor="role" className="form-label">
              Select Role <span className="text-danger">*</span>
            </label>
            <Select
              name="role"
              options={roleList}
              classNamePrefix="select"
              value={formData.role}
              onChange={(selected) => handleSelectChange("role", selected)}
            />
            <div className="text-danger">
              {errors.role && <>{errors.role}</>}
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="mb-3">
            <label htmlFor="manager" className="form-label">
              Select Manager{" "}
            </label>
            <Select
              name="manager"
              options={usersList?.data}
              classNamePrefix="select"
              value={formData.manager}
              onChange={(selected) => handleSelectChange("manager", selected)}
            />
            <div className="text-danger">
              {errors.manager && <>{errors.manager}</>}
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="mb-3">
            <label htmlFor="manager" className="form-label">
              Add Credits <span></span>
            </label>
            <input
              type="text"
              className="form-control"
              name="credit_in"
              placeholder="Enter add credits value"
              maxLength={10}
              value={formData.credit_in}
              onChange={handleChange}
            />
            <div className="text-danger">
              {errors.credit_in && <>{errors.credit_in}</>}
            </div>
          </div>
        </div>
        {/* <div className="col-md-6">
          <div className="mt-3">
            <label htmlFor="manager" className="form-label pt-3">Credit Available :  <span cclassName="text-danger">78/100</span></label>
           
          </div>
        </div> */}
        <div className="col-md-8 d-flex justify-content-end">
          <div className="col-md-2">
            <p className="text-danger text-center">
              {!errorData.length > 0 && loginError}
            </p>
            <div className="mt-4">
              <button
                className="btn btn-success w-100"
                type="submit"
                onClick={handleSubmit}
              >
                Create User
              </button>
            </div>
          </div></div>
      </div>
      <div className="row mt-4">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">User List</h5>
              <div className="row mb-2">
                <div className="col-md-2">
                  <label className="small">Select Records</label>
                  <Select
                    options={[
                      { value: 10, label: "10" },
                      { value: 25, label: "25" },
                      { value: 50, label: "50" },
                      { value: 100, label: "100" },
                      { value: 2000, label: "All" },
                    ]}
                    defaultValue={{ value: 10, label: "10" }}
                    onChange={(e) => {
                      setRecordsPerPage(e.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile No</th>
                      <th>Role</th>
                      <th>Manager</th>
                      <th>Credits</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(usersTableList) &&
                      usersTableList.length > 0 ? (
                      currentData.map((user, index) => (
                        <tr key={user.id || index}>
                          <td>
                            {recordsPerPage === 2000
                              ? index + 1
                              : (currentPage - 1) * recordsPerPage + index + 1}
                          </td>
                          <td>{user.name}</td>
                          <td>{user.email}</td>
                          <td>{user.mobile_no}</td>
                          <td>{user.role_name || "-"}</td>
                          <td>{user.MgrName || "-"}</td>
                          <td>
                            {Number(user.credit_out) > 0 ||
                              Number(user.credit_in) > 0
                              ? `${user.credit_out || 0} / ${user.credit_in || 0}`
                              : "-"}
                          </td>
                          <td>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top">
                                  Edit User Details
                                </Tooltip>
                              }
                            >
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => handleEdit(user)}
                              >
                                <i className="ri-edit-fill align-bottom"></i>
                              </button>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No users found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row mt-2 px-2">
              <div className="col-md-6">
                Showing {totalRecords === 0 ? 0 : indexOfFirst + 1} to{" "}
                {Math.min(indexOfLast, totalRecords)} of {totalRecords}
              </div>

              <div className="col-md-6">
                <ul className="pagination justify-content-end">
                  {/* PREV */}
                  <li
                    className={`page-item ${currentPage === 1 && "disabled"}`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                    >
                      Prev
                    </button>
                  </li>

                  {/* PAGE NUMBERS */}
                  {getPaginationItems(currentPage, totalPages).map((page, i) =>
                    page === "..." ? (
                      <li key={i} className="page-item disabled">
                        <span className="page-link">...</span>
                      </li>
                    ) : (
                      <li
                        key={i}
                        className={`page-item ${page === currentPage ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      </li>
                    ),
                  )}

                  {/* NEXT */}
                  <li
                    className={`page-item ${currentPage === totalPages && "disabled"
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientSignUp;
